module.exports = {"id":"229038","name":"Christian Rivera","rating":"71","photo":"./data/images/photos/4/229038.png","club":{"name":"FC Barcelone B","logo":"./data/images/clubs/FCBarceloneB.png"},"positions":["MDC","MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ChristianRivera0.json
// module id = 802
// module chunks = 0